import { getCoverageLineConfig } from '@common/config';
import { isEmpty } from 'lodash';
import { Highlight, Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import { InsuranceProduct } from 'types';
import { truncateMultiLineText } from 'utils';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import { getCoverageLayerLabel } from 'broker/utils';

export interface ProductDescriptionProps {
  product: InsuranceProduct;
  searchInput: string;
}

const {
  isAdmitted: { admitted, nonAdmitted },
  incumbent,
} = messages.addProductsPage.additionalFilters;

export function ProductDescription({ product, searchInput }: ProductDescriptionProps) {
  const { id: productId, marketName, coverageLayer, isAdmitted, label, coverageLines } = product;
  const { partialSubmission } = useSubmissionsWorkspace();
  const isIncumbent = partialSubmission?.additionalData.expiringPolicyData?.[0].insuranceProductId === productId;

  const productCoverageLines = coverageLines
    .map((productCoverageLine) => getCoverageLineConfig(productCoverageLine.coverageLine).text)
    .join(', ');
  const coverageLayerLabel = getCoverageLayerLabel(coverageLayer);
  const isAdmittedLabel = isAdmitted ? admitted : nonAdmitted;

  const productDetails = `${
    !isEmpty(coverageLines) ? `${productCoverageLines} | ` : ''
  } ${coverageLayerLabel} | ${isAdmittedLabel}`;

  return (
    <Stack gap={0.5}>
      <Stack>
        <Stack direction="row" gap={0.5}>
          <Typography fontWeight="bold" variant="body2" sx={{ ...truncateMultiLineText(2) }}>
            <Highlight searchWords={[searchInput]} textToHighlight={marketName} />
          </Typography>
          {isIncumbent && (
            <Stack justifyContent="center">
              <Typography variant="caption" color="typography.nonEssential">
                {`(${incumbent})`}
              </Typography>
            </Stack>
          )}
        </Stack>
        {label && <Typography variant="captionBold">{label}</Typography>}
      </Stack>
      <Stack direction="row" gap={0.5} flexWrap="wrap">
        <Typography title={productDetails} sx={{ ...truncateMultiLineText(4) }} variant="caption">
          {productDetails}
        </Typography>
      </Stack>
    </Stack>
  );
}
